
export default {
  props: ['error'],
  layout: 'whiteHeader'
}
